import React from 'react'
import { Select } from '@/components'
import { APIClient } from '@/services'
import { QuestionProps } from '../types'

export const SeniorityCard = (props: QuestionProps) => {
  const { form, disabled } = props

  const { data: options } = APIClient.Session.useProfileOptions()

  return (
    <Select
      label='Seniority'
      options={options?.seniority ?? []}
      {...form.register('seniority')}
      arrowIconName='chevron-right'
      placeholder='Select one'
      variants={['noError', 'prompt']}
      disabled={disabled}
    />
  )
}
